/* eslint-disable no-restricted-imports */
import { useState } from 'react';

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  Add,
  Cancel,
  Check,
  CheckCircle,
  Close,
  Edit,
  Remove,
  ShoppingCart,
} from '@material-ui/icons';

import { Skeleton } from '@mui/material';
import { FormatMoney } from 'components';

import { useStyles } from './styles';

export function PartsTable({
  components,
  loadingBudgetData,
  updateComponent,
  updateComponentPrice,
}) {
  const classes = useStyles();

  const [editingPrice, setEditingPrice] = useState();
  const [tempPrice, setTempPrice] = useState();

  const getStatusClass = (status) => {
    switch (status) {
      case 'disponivel':
        return classes.statusDisponivel;
      case 'indisponivel':
        return classes.statusIndisponivel;
      case 'selecionado':
        return classes.statusSelecionado;
      default:
        return '';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'disponivel':
        return <CheckCircle style={{ color: '#4caf50', fontSize: 20 }} />;
      case 'indisponivel':
        return <Cancel style={{ color: '#f44336', fontSize: 20 }} />;
      case 'selecionado':
        return <ShoppingCart style={{ color: '#2196f3', fontSize: 20 }} />;
      default:
        return null;
    }
  };

  const handlePriceEdit = (componentId, currentPrice) => {
    setEditingPrice(componentId);
    setTempPrice(currentPrice);
  };

  const handlePriceSave = (componentId) => {
    updateComponentPrice(componentId, tempPrice);
    setEditingPrice(null);
  };

  const handlePriceCancel = () => {
    setEditingPrice(null);
    setTempPrice(0);
  };

  return (
    <TableContainer className={classes.tableContainer}>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell align='right'>Preço Custo</TableCell>
            <TableCell align='right'>Preço Venda</TableCell>
            <TableCell align='center'>Qtde</TableCell>
            <TableCell align='center'>Estoque</TableCell>
            <TableCell align='center'>Status</TableCell>
            <TableCell align='center'>Selecionado Por</TableCell>
            <TableCell align='center'>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loadingBudgetData
            ? Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant='text' width='80%' />
                  </TableCell>
                  <TableCell align='right'>
                    <Skeleton variant='text' width={60} style={{ marginLeft: 'auto' }} />
                  </TableCell>
                  <TableCell align='right'>
                    <Skeleton variant='text' width={60} style={{ marginLeft: 'auto' }} />
                  </TableCell>
                  <TableCell align='center'>
                    <Skeleton variant='text' width={30} style={{ margin: '0 auto' }} />
                  </TableCell>
                  <TableCell align='center'>
                    <Skeleton variant='text' width={30} style={{ margin: '0 auto' }} />
                  </TableCell>
                  <TableCell align='center'>
                    <Skeleton
                      variant='circle'
                      width={20}
                      height={20}
                      style={{ margin: '0 auto' }}
                    />
                  </TableCell>
                  <TableCell align='center'>
                    <Skeleton variant='text' width={60} style={{ margin: '0 auto' }} />
                  </TableCell>
                  <TableCell align='center'>
                    <Box display='flex' justifyContent='center' gap={0.5}>
                      <Skeleton variant='circle' width={24} height={24} />
                      <Skeleton variant='circle' width={24} height={24} />
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            : components.map((component) => {
                const isOutOfStock = component.stockAmount <= 0;
                return (
                  <TableRow
                    key={component.id}
                    className={getStatusClass(component.status)}
                    style={{ backgroundColor: isOutOfStock ? '#ffebee' : undefined }}
                  >
                    <TableCell>
                      <Typography variant='body2' style={{ fontWeight: 600 }}>
                        {component.description}
                      </Typography>
                      {isOutOfStock && (
                        <Typography
                          variant='caption'
                          style={{ color: '#d32f2f', display: 'block' }}
                        >
                          Peça não está em estoque
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align='right'>
                      <Typography variant='body2'>
                        <FormatMoney>{component.costPrice}</FormatMoney>
                      </Typography>
                    </TableCell>
                    <TableCell align='right'>
                      {editingPrice === component.id ? (
                        <Box display='flex' alignItems='center' justifyContent='flex-end' gap={1}>
                          <TextField
                            type='number'
                            value={tempPrice}
                            onChange={(e) =>
                              setTempPrice(parseFloat(e.target.value > 0 ? e.target.value : 0) || 0)
                            }
                            size='small'
                            style={{ width: 80 }}
                            inputProps={{ step: 0.01 }}
                          />
                          <IconButton size='small' onClick={() => handlePriceSave(component.id)}>
                            <Check fontSize='small' style={{ color: '#4caf50' }} />
                          </IconButton>
                          <IconButton size='small' onClick={handlePriceCancel}>
                            <Close fontSize='small' style={{ color: '#f44336' }} />
                          </IconButton>
                        </Box>
                      ) : (
                        <Box display='flex' alignItems='center' justifyContent='flex-end' gap={1}>
                          <Typography variant='body2'>
                            <FormatMoney>{component.sellPrice}</FormatMoney>
                          </Typography>
                          <IconButton
                            size='small'
                            onClick={() => handlePriceEdit(component.id, component.sellPrice)}
                          >
                            <Edit fontSize='small' />
                          </IconButton>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell align='center'>{component.amount}</TableCell>
                    <TableCell align='center'>
                      <Typography
                        variant='body2'
                        style={{
                          color: isOutOfStock ? '#d32f2f' : '#4caf50',
                          fontWeight: 600,
                        }}
                      >
                        {component.stockAmount}
                      </Typography>
                    </TableCell>
                    <TableCell align='center'>{getStatusIcon(component.status)}</TableCell>
                    <TableCell align='center'>
                      {component.selectedByTechnician ? (
                        <Typography variant='caption' style={{ color: '#2196f3', fontWeight: 600 }}>
                          Técnico
                        </Typography>
                      ) : component.selected ? (
                        <Typography variant='caption' style={{ color: '#4caf50', fontWeight: 600 }}>
                          Atendente
                        </Typography>
                      ) : (
                        <Typography variant='caption' style={{ color: '#9e9e9e' }}>
                          -
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align='center'>
                      <Box display='flex' justifyContent='center' gap={0.5}>
                        <IconButton
                          size='small'
                          onClick={() =>
                            updateComponent(component.id, Math.max(0, component.amount - 1))
                          }
                          disabled={component.status === 'indisponivel'}
                        >
                          <Remove fontSize='small' />
                        </IconButton>
                        <IconButton
                          size='small'
                          onClick={() => updateComponent(component.id, component.amount + 1)}
                          disabled={component.status === 'indisponivel'}
                        >
                          <Add fontSize='small' />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
